import { baseThemeValues } from 'constants/common';

const baseProps = {
  borderRadius: '3px',
  borderWidth: '2px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 500,
  shadowSize: '7px',
};

export const checkboxTheme = {
  checked: {
    base: {
      ...baseProps,
      bg: 'palette.primary.20',
      borderColor: 'palette.primary.20',
      checkMark: 'palette.surface.4',
      shadowColor: 'palette.transparent',
      text: 'palette.tertiary.95',
    },
    baseProps,
    disabled: {
      ...baseProps,
      bg: 'palette.neutral.40',
      borderColor: 'palette.neutral.40',
      checkMark: 'palette.surface.4',
      shadowColor: 'palette.transparent',
      text: 'palette.neutral.40',
    },
    hover: {
      ...baseProps,
      bg: 'palette.primary.30',
      borderColor: 'palette.primary.30',
      checkMark: 'palette.surface.4',
      shadowColor: 'palette.tertiary.10',
      text: 'palette.tertiary.95',
    },
    pressed: {
      ...baseProps,
      bg: 'palette.primary.20',
      borderColor: 'palette.primary.20',
      checkMark: 'palette.surface.4',
      shadowColor: 'palette.tertiary.10',
      text: 'palette.tertiary.95',
    },
  },
  notChecked: {
    base: {
      ...baseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.tertiary.40',
      checkMark: 'palette.transparent',
      shadowColor: 'palette.transparent',
      text: 'palette.tertiary.95',
    },
    baseProps,
    disabled: {
      ...baseProps,
      bg: 'palette.transparent',
      borderColor: 'palette.neutral.40',
      checkMark: 'palette.transparent',
      shadowColor: 'palette.transparent',
      text: 'palette.neutral.40',
    },
    hover: {
      ...baseProps,
      bg: 'palette.tertiary.10',
      borderColor: 'palette.tertiary.70',
      checkMark: 'palette.transparent',
      shadowColor: 'palette.tertiary.10',
      text: 'palette.tertiary.95',
    },
    pressed: {
      ...baseProps,
      bg: 'palette.tertiary.10',
      borderColor: 'palette.tertiary.80',
      checkMark: 'palette.transparent',
      shadowColor: 'palette.tertiary.10',
      text: 'palette.tertiary.95',
    },
  },
};
